"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateFileUploadUrlMutation = exports.CreateFileUploadUrlDocument = exports.useCreateCustomTransactionMutation = exports.CreateCustomTransactionDocument = exports.useCreateAppMutation = exports.CreateAppDocument = exports.useCreateAdminUserMutation = exports.CreateAdminUserDocument = exports.useCompleteMarketplacePurchaseMutation = exports.CompleteMarketplacePurchaseDocument = exports.useCompleteMarketplaceListMutation = exports.CompleteMarketplaceListDocument = exports.useCompleteMarketplaceCancelMutation = exports.CompleteMarketplaceCancelDocument = exports.useCompleteCheckoutWithDapperWalletMutation = exports.CompleteCheckoutWithDapperWalletDocument = exports.useCheckoutMutation = exports.CheckoutDocument = exports.useCheckoutWithDapperWalletMutation = exports.CheckoutWithDapperWalletDocument = exports.useApproveCustomTransactionMutation = exports.ApproveCustomTransactionDocument = exports.useAddCredentialMutation = exports.AddCredentialDocument = exports.useAcceptAdminUserTosMutation = exports.AcceptAdminUserTosDocument = exports.BlockchainTransactionState = exports.WalletType = exports.WalletState = exports.TransferState = exports.Status = exports.SimpleRarityLevel = exports.SaleState = exports.SaleProcessingState = exports.Role = exports.OrganizationRole = exports.NftSetBlockchainState = exports.NftModelBlockchainState = exports.NftBlockchainState = exports.MarketplaceListingState = exports.ListingState = exports.KmsKeyProviderType = exports.InvoiceState = exports.FileState = exports.CustomTransactionState = exports.Currency = exports.CredentialType = exports.ContractVersion = exports.ContractState = exports.Blockchain = void 0;
exports.useUpdateCredentialMutation = exports.UpdateCredentialDocument = exports.useUpdateContractMutation = exports.UpdateContractDocument = exports.useUpdateAppMutation = exports.UpdateAppDocument = exports.useUpdateAdminUserMutation = exports.UpdateAdminUserDocument = exports.useTransferMutation = exports.TransferDocument = exports.useSignTransactionMutation = exports.SignTransactionDocument = exports.useSignTransactionForDapperWalletMutation = exports.SignTransactionForDapperWalletDocument = exports.useSetPrimaryWalletMutation = exports.SetPrimaryWalletDocument = exports.useReserveMutation = exports.ReserveDocument = exports.useRegisterWalletMutation = exports.RegisterWalletDocument = exports.useReadyWalletMutation = exports.ReadyWalletDocument = exports.useMintNftModelMutation = exports.MintNftModelDocument = exports.useExecuteTransactionMutation = exports.ExecuteTransactionDocument = exports.useDeployContractMutation = exports.DeployContractDocument = exports.useDeleteOrganizationMemberMutation = exports.DeleteOrganizationMemberDocument = exports.useDeleteNftSetMutation = exports.DeleteNftSetDocument = exports.useDeleteNftModelMutation = exports.DeleteNftModelDocument = exports.useDeleteNftListingMutation = exports.DeleteNftListingDocument = exports.useDeleteCustomTransactionMutation = exports.DeleteCustomTransactionDocument = exports.useDeleteCredentialMutation = exports.DeleteCredentialDocument = exports.useCreateOrganizationMutation = exports.CreateOrganizationDocument = exports.useCreateNiftoryWalletMutation = exports.CreateNiftoryWalletDocument = exports.useCreateNftSetMutation = exports.CreateNftSetDocument = exports.useCreateNftModelMutation = exports.CreateNftModelDocument = exports.useCreateNftListingMutation = exports.CreateNftListingDocument = void 0;
exports.useMarketplaceListingQuery = exports.MarketplaceListingDocument = exports.useInvoicesQuery = exports.InvoicesDocument = exports.useFileQuery = exports.FileDocument = exports.useCustomTransactionsQuery = exports.CustomTransactionsDocument = exports.useCustomTransactionQuery = exports.CustomTransactionDocument = exports.useContractQuery = exports.ContractDocument = exports.useStatsQuery = exports.StatsDocument = exports.useBlockchainTransactionQuery = exports.BlockchainTransactionDocument = exports.useAppsQuery = exports.AppsDocument = exports.useAppQuery = exports.AppDocument = exports.useAppUsersQuery = exports.AppUsersDocument = exports.useAppUserQuery = exports.AppUserDocument = exports.useAppUserByIdQuery = exports.AppUserByIdDocument = exports.useAppByIdQuery = exports.AppByIdDocument = exports.useAdminUsersQuery = exports.AdminUsersDocument = exports.useAdminUserQuery = exports.AdminUserDocument = exports.useAdminUserByIdQuery = exports.AdminUserByIdDocument = exports.useWithdrawMutation = exports.WithdrawDocument = exports.useVerifyWalletMutation = exports.VerifyWalletDocument = exports.useUploadNftContentMutation = exports.UploadNftContentDocument = exports.useUpdateOrganizationMutation = exports.UpdateOrganizationDocument = exports.useUpdateOrganizationMemberMutation = exports.UpdateOrganizationMemberDocument = exports.useUpdateNftSetMutation = exports.UpdateNftSetDocument = exports.useUpdateNftModelMutation = exports.UpdateNftModelDocument = exports.useUpdateNftListingMutation = exports.UpdateNftListingDocument = void 0;
exports.useWalletQuery = exports.WalletDocument = exports.useWalletStatsQuery = exports.WalletStatsDocument = exports.useWalletsQuery = exports.WalletsDocument = exports.useWalletByIdQuery = exports.WalletByIdDocument = exports.useWalletByAddressQuery = exports.WalletByAddressDocument = exports.useUserStatsQuery = exports.UserStatsDocument = exports.useSetsQuery = exports.SetsDocument = exports.useSetQuery = exports.SetDocument = exports.useSaleStatsQuery = exports.SaleStatsDocument = exports.useOrganizationByIdQuery = exports.OrganizationByIdDocument = exports.useNftsQuery = exports.NftsDocument = exports.useNftsByWalletQuery = exports.NftsByWalletDocument = exports.useNftQuery = exports.NftDocument = exports.useNftSetsQuery = exports.NftSetsDocument = exports.useNftModelsQuery = exports.NftModelsDocument = exports.useNftModelQuery = exports.NftModelDocument = exports.useNftListingsQuery = exports.NftListingsDocument = exports.useNftListingQuery = exports.NftListingDocument = exports.useMarketplaceListingsQuery = exports.MarketplaceListingsDocument = void 0;
const tslib_1 = require("tslib");
// eslint-disable
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const Urql = tslib_1.__importStar(require("urql"));
/** The blockchains supported by Niftory. */
var Blockchain;
(function (Blockchain) {
    /** The Ethereum blockchain. https://ethereum.org/en/ */
    Blockchain["Ethereum"] = "ETHEREUM";
    /** The Flow blockchain. https://www.onflow.org/ */
    Blockchain["Flow"] = "FLOW";
    /** The Polygon blockchain. https://polygon.technology/ */
    Blockchain["Polygon"] = "POLYGON";
})(Blockchain = exports.Blockchain || (exports.Blockchain = {}));
/** The state of a contract on the blockchain */
var ContractState;
(function (ContractState) {
    /** The contract has been created but deployment hasn't started yet. */
    ContractState["Created"] = "CREATED";
    /** The contract is being deployed. */
    ContractState["Deploying"] = "DEPLOYING";
    /** The contract deployment failed. */
    ContractState["DeployFailed"] = "DEPLOY_FAILED";
    /** The contract has been deployed. */
    ContractState["Ready"] = "READY";
    /** The contract update failed. */
    ContractState["UpdateFailed"] = "UPDATE_FAILED";
    /** The contract is being updated. */
    ContractState["Updating"] = "UPDATING";
})(ContractState = exports.ContractState || (exports.ContractState = {}));
/** The type of contract versions. */
var ContractVersion;
(function (ContractVersion) {
    ContractVersion["V1"] = "V1";
    ContractVersion["V2"] = "V2";
    ContractVersion["V2_1"] = "V2_1";
    ContractVersion["V2_1_1"] = "V2_1_1";
    ContractVersion["V2_2"] = "V2_2";
})(ContractVersion = exports.ContractVersion || (exports.ContractVersion = {}));
/** The type of client for Niftory authentication. */
var CredentialType;
(function (CredentialType) {
    /** A client that can't keep secrets (e.g. TV or game console). */
    CredentialType["Device"] = "DEVICE";
    /** A server-side client that can keep secrets. */
    CredentialType["Server"] = "SERVER";
})(CredentialType = exports.CredentialType || (exports.CredentialType = {}));
/** A currency that can be accepted for payment. */
var Currency;
(function (Currency) {
    /** The dapper utility token */
    Currency["Duc"] = "DUC";
    /** The flow token */
    Currency["Flow"] = "FLOW";
    /** The flow utility token */
    Currency["Fut"] = "FUT";
    /** The United States dollar. */
    Currency["Usd"] = "USD";
})(Currency = exports.Currency || (exports.Currency = {}));
/** The state of a custom blockchain transaction. */
var CustomTransactionState;
(function (CustomTransactionState) {
    /** The transaction has been allowed by an admin. */
    CustomTransactionState["Allowed"] = "ALLOWED";
    /** The transaction is pending. */
    CustomTransactionState["Submitted"] = "SUBMITTED";
})(CustomTransactionState = exports.CustomTransactionState || (exports.CustomTransactionState = {}));
/** The upload state of a File. */
var FileState;
(function (FileState) {
    /** The file failed to ready. */
    FileState["Error"] = "ERROR";
    /** Niftory has created a pre-signed URL where the file can be uploaded. */
    FileState["GeneratedUploadUrl"] = "GENERATED_UPLOAD_URL";
    /** Niftory has created a file entry in the database table. */
    FileState["Pending"] = "PENDING";
    /** The file is ready for use. */
    FileState["Ready"] = "READY";
    /** The file has been uploaded to a cloud storage for fast retrieval. */
    FileState["UploadedToCloudStorage"] = "UPLOADED_TO_CLOUD_STORAGE";
    /** The file (and potentially its corresponding metadata) have been uploaded to IPFS. */
    FileState["UploadedToIpfs"] = "UPLOADED_TO_IPFS";
})(FileState = exports.FileState || (exports.FileState = {}));
/** The state of an invoice. */
var InvoiceState;
(function (InvoiceState) {
    /** This invoice is completed. */
    InvoiceState["Completed"] = "COMPLETED";
    /** This invoice was created and ready for payment. */
    InvoiceState["Created"] = "CREATED";
    /** An error was encountered while performing this payment. */
    InvoiceState["Error"] = "ERROR";
    /** This invoice is pending payment. */
    InvoiceState["Pending"] = "PENDING";
})(InvoiceState = exports.InvoiceState || (exports.InvoiceState = {}));
/** The type of kms key types. */
var KmsKeyProviderType;
(function (KmsKeyProviderType) {
    /** The aws kms key provider */
    KmsKeyProviderType["AwsKmsKeyProvider"] = "AWS_KMS_KEY_PROVIDER";
    /** The GCP kms key provider */
    KmsKeyProviderType["GcpKmsKeyProvider"] = "GCP_KMS_KEY_PROVIDER";
})(KmsKeyProviderType = exports.KmsKeyProviderType || (exports.KmsKeyProviderType = {}));
/** The state of a listing. */
var ListingState;
(function (ListingState) {
    /**
     * The listing is active and available for sale.
     * @deprecated Use SHOW_IN_STORE instead
     */
    ListingState["Active"] = "ACTIVE";
    /** The listing is inactive, so it's not open for sale. */
    ListingState["HideFromStore"] = "HIDE_FROM_STORE";
    /**
     * The listing is inactive, so it's not open for sale.
     * @deprecated Use HIDE_FROM_STORE instead
     */
    ListingState["Inactive"] = "INACTIVE";
    /** All NFTs in this listing have been sold. */
    ListingState["NotAvailaibleForPurchase"] = "NOT_AVAILAIBLE_FOR_PURCHASE";
    /** The listing is active and available for sale. */
    ListingState["ShowInStore"] = "SHOW_IN_STORE";
    /**
     * All NFTs in this listing have been sold.
     * @deprecated Use NOT_AVAILAIBLE_FOR_PURCHASE instead
     */
    ListingState["Sold"] = "SOLD";
})(ListingState = exports.ListingState || (exports.ListingState = {}));
/** The state of an Marketplace listing */
var MarketplaceListingState;
(function (MarketplaceListingState) {
    /** The marketplace listing is available for purchase */
    MarketplaceListingState["Available"] = "AVAILABLE";
    /** The marketplace listing is cancelled */
    MarketplaceListingState["Cancelled"] = "CANCELLED";
    /** The marketplace listing has expired */
    MarketplaceListingState["Expired"] = "EXPIRED";
    /** The marketplace listing has already been purchased */
    MarketplaceListingState["Purchased"] = "PURCHASED";
})(MarketplaceListingState = exports.MarketplaceListingState || (exports.MarketplaceListingState = {}));
/** The state of an NFT on the blockchain. */
var NftBlockchainState;
(function (NftBlockchainState) {
    /** An error occurred with this item's last blockchain operation. */
    NftBlockchainState["Error"] = "ERROR";
    /** The item is minted, and are no pending operations on it. */
    NftBlockchainState["Minted"] = "MINTED";
    /** The item is being minted. */
    NftBlockchainState["Minting"] = "MINTING";
    /** The item has already been transferred to a user's wallet. */
    NftBlockchainState["Transferred"] = "TRANSFERRED";
    /** The item is being transferred. */
    NftBlockchainState["Transferring"] = "TRANSFERRING";
    /** The item hasn't been minted yet. */
    NftBlockchainState["Unminted"] = "UNMINTED";
})(NftBlockchainState = exports.NftBlockchainState || (exports.NftBlockchainState = {}));
/** The state of an NFT Model on the blockchain. */
var NftModelBlockchainState;
(function (NftModelBlockchainState) {
    /** All NFTs in this model have been transferred to users. */
    NftModelBlockchainState["Completed"] = "COMPLETED";
    /** An error occurred with this item's last blockchain operation. */
    NftModelBlockchainState["Error"] = "ERROR";
    /** The item is minted, and are no pending operations on it. */
    NftModelBlockchainState["Minted"] = "MINTED";
    /** The item is being minted. */
    NftModelBlockchainState["Minting"] = "MINTING";
    /** The item hasn't been minted yet. */
    NftModelBlockchainState["Unminted"] = "UNMINTED";
})(NftModelBlockchainState = exports.NftModelBlockchainState || (exports.NftModelBlockchainState = {}));
/** The state of an NFT Set on the blockchain. */
var NftSetBlockchainState;
(function (NftSetBlockchainState) {
    /** An error occurred with this item's last blockchain operation. */
    NftSetBlockchainState["Error"] = "ERROR";
    /** The item is minted, and are no pending operations on it. */
    NftSetBlockchainState["Minted"] = "MINTED";
    /** The item is being minted. */
    NftSetBlockchainState["Minting"] = "MINTING";
    /** The item hasn't been minted yet. */
    NftSetBlockchainState["Unminted"] = "UNMINTED";
})(NftSetBlockchainState = exports.NftSetBlockchainState || (exports.NftSetBlockchainState = {}));
/** The role of an admin in an organization. */
var OrganizationRole;
(function (OrganizationRole) {
    OrganizationRole["Admin"] = "ADMIN";
    OrganizationRole["Member"] = "MEMBER";
})(OrganizationRole = exports.OrganizationRole || (exports.OrganizationRole = {}));
/** Roles for users of the Niftory admin portal and APIs. */
var Role;
(function (Role) {
    /** Can do anything a minter can, and manage users and permissions. */
    Role["Administrator"] = "ADMINISTRATOR";
    /** Can create blockchain objects like models and sets. */
    Role["Creator"] = "CREATOR";
    /** Can do anything a creator can, but also manage listings */
    Role["Manager"] = "MANAGER";
    /** Can do anything a manager can, and also perform blockchain actions like minting. */
    Role["Minter"] = "MINTER";
})(Role = exports.Role || (exports.Role = {}));
/** The state of an item for sale. */
var SaleProcessingState;
(function (SaleProcessingState) {
    /** This item is available for sale. */
    SaleProcessingState["Available"] = "AVAILABLE";
    /** This item was created, but not yet available for sale. */
    SaleProcessingState["Created"] = "CREATED";
    /** An error was encountered while selling this item. */
    SaleProcessingState["Error"] = "ERROR";
    /** The user has purchased the item, but it's not yet cleared for transfer to their wallet. */
    SaleProcessingState["Locked"] = "LOCKED";
    /** This item is reserved for a user, but not yet purchased. */
    SaleProcessingState["Reserved"] = "RESERVED";
    /** The item has been sold and transferred to a user's wallet. */
    SaleProcessingState["Sold"] = "SOLD";
    /** The item is in the process of being transferred to the user's wallet. */
    SaleProcessingState["Transferring"] = "TRANSFERRING";
})(SaleProcessingState = exports.SaleProcessingState || (exports.SaleProcessingState = {}));
/** The state of an item being sold. */
var SaleState;
(function (SaleState) {
    /** The item has not been reserved or purchased yet. */
    SaleState["Available"] = "AVAILABLE";
    /** The item has been delivered. */
    SaleState["Fulfilled"] = "FULFILLED";
    /** The item has been paid for and is being fulfilled. */
    SaleState["Paid"] = "PAID";
    /** The item is reserved for a future purchase. */
    SaleState["Reserved"] = "RESERVED";
})(SaleState = exports.SaleState || (exports.SaleState = {}));
/** The default rarity levels in the Niftory API. */
var SimpleRarityLevel;
(function (SimpleRarityLevel) {
    /** The most common NFTs. */
    SimpleRarityLevel["Common"] = "COMMON";
    /** The rarest of the rare NFTs, for the most dedicated collectors. */
    SimpleRarityLevel["Legendary"] = "LEGENDARY";
    /** These are rarer, harder to get and more expensive. */
    SimpleRarityLevel["Rare"] = "RARE";
})(SimpleRarityLevel = exports.SimpleRarityLevel || (exports.SimpleRarityLevel = {}));
/** Status of this resource for user workflows. */
var Status;
(function (Status) {
    /** "Here you go!" */
    Status["Done"] = "DONE";
    /** "I'm just getting started." */
    Status["Draft"] = "DRAFT";
    /** "I'm working on it!" */
    Status["InProgress"] = "IN_PROGRESS";
    /** "I'll get to it eventually..." */
    Status["ToDo"] = "TO_DO";
})(Status = exports.Status || (exports.Status = {}));
/** The state of an item being transferred. */
var TransferState;
(function (TransferState) {
    /** The item has been created, but not transferred. */
    TransferState["Available"] = "AVAILABLE";
    /** The item failed to transfer. */
    TransferState["Error"] = "ERROR";
    /** The item is being transferred. */
    TransferState["InProgress"] = "IN_PROGRESS";
    /** The item is reserved for a future transfer. */
    TransferState["Reserved"] = "RESERVED";
    /** The item has been transferred. */
    TransferState["Success"] = "SUCCESS";
})(TransferState = exports.TransferState || (exports.TransferState = {}));
/** The state of a wallet. */
var WalletState;
(function (WalletState) {
    /** (Niftory Wallet Only) The Niftory wallet failed to be created on the blockchain. */
    WalletState["CreationFailed"] = "CREATION_FAILED";
    /** (Niftory Wallet Only) The Niftory wallet is in the process of being created on-chain. The address and state of the Wallet object will be updated once complete. */
    WalletState["PendingCreation"] = "PENDING_CREATION";
    /** The wallet is ready to receive NFTs from this app's contract. */
    WalletState["Ready"] = "READY";
    /** The wallet has been registered with Niftory, but not yet verified to belong to the signed-in user. */
    WalletState["Unverified"] = "UNVERIFIED";
    /** The wallet is verified to belong to the signed-in user, but not yet ready to receive NFTs from this app's contract. */
    WalletState["Verified"] = "VERIFIED";
})(WalletState = exports.WalletState || (exports.WalletState = {}));
/** The type of wallet. */
var WalletType;
(function (WalletType) {
    /** An external wallet linked by the user. */
    WalletType["External"] = "EXTERNAL";
    /** A wallet created by the niftory API. */
    WalletType["Niftory"] = "NIFTORY";
})(WalletType = exports.WalletType || (exports.WalletType = {}));
/** The state of a blockchain transaction. */
var BlockchainTransactionState;
(function (BlockchainTransactionState) {
    /** The transaction hasn't been completed yet. */
    BlockchainTransactionState["Pending"] = "PENDING";
    /** The transaction has been completed. */
    BlockchainTransactionState["Sealed"] = "SEALED";
})(BlockchainTransactionState = exports.BlockchainTransactionState || (exports.BlockchainTransactionState = {}));
exports.AcceptAdminUserTosDocument = (0, graphql_tag_1.default) `
    mutation AcceptAdminUserTOS {
  acceptAdminUserTOS {
    id
    tosAcceptanceDateTime
  }
}
    `;
function useAcceptAdminUserTosMutation() {
    return Urql.useMutation(exports.AcceptAdminUserTosDocument);
}
exports.useAcceptAdminUserTosMutation = useAcceptAdminUserTosMutation;
;
exports.AddCredentialDocument = (0, graphql_tag_1.default) `
    mutation addCredential($appId: ID!, $data: CredentialUpdateInput, $type: CredentialType) {
  addCredential(appId: $appId, data: $data, type: $type) {
    apiKey
    clientId
    clientSecret
    redirectUris
    type
  }
}
    `;
function useAddCredentialMutation() {
    return Urql.useMutation(exports.AddCredentialDocument);
}
exports.useAddCredentialMutation = useAddCredentialMutation;
;
exports.ApproveCustomTransactionDocument = (0, graphql_tag_1.default) `
    mutation ApproveCustomTransaction($approveCustomTransactionId: ID) {
  approveCustomTransaction(id: $approveCustomTransactionId) {
    appId
    approvalState
    code
    hash
    id
    metadataScript
    name
  }
}
    `;
function useApproveCustomTransactionMutation() {
    return Urql.useMutation(exports.ApproveCustomTransactionDocument);
}
exports.useApproveCustomTransactionMutation = useApproveCustomTransactionMutation;
;
exports.CheckoutWithDapperWalletDocument = (0, graphql_tag_1.default) `
    mutation CheckoutWithDapperWallet($nftModelId: ID!, $address: String, $expiry: UnsignedInt, $price: UnsignedFloat, $userId: ID, $walletId: ID) {
  checkoutWithDapperWallet(
    nftModelId: $nftModelId
    address: $address
    expiry: $expiry
    price: $price
    userId: $userId
    walletId: $walletId
  ) {
    brand
    cadence
    expiry
    merchantAccountAddress
    nftDatabaseId
    nftId
    nftTypeRef
    price
    registryAddress
    setId
    signerAddress
    signerKeyId
    templateId
  }
}
    `;
function useCheckoutWithDapperWalletMutation() {
    return Urql.useMutation(exports.CheckoutWithDapperWalletDocument);
}
exports.useCheckoutWithDapperWalletMutation = useCheckoutWithDapperWalletMutation;
;
exports.CheckoutDocument = (0, graphql_tag_1.default) `
    mutation checkout($invoiceId: String!, $onError: String!, $onSuccess: String!) {
  checkout(invoiceId: $invoiceId, onError: $onError, onSuccess: $onSuccess) {
    redirectUrl
    status
    statusMessage
  }
}
    `;
function useCheckoutMutation() {
    return Urql.useMutation(exports.CheckoutDocument);
}
exports.useCheckoutMutation = useCheckoutMutation;
;
exports.CompleteCheckoutWithDapperWalletDocument = (0, graphql_tag_1.default) `
    mutation CompleteCheckoutWithDapperWallet($transactionId: String!, $nftDatabaseId: String) {
  completeCheckoutWithDapperWallet(
    transactionId: $transactionId
    nftDatabaseId: $nftDatabaseId
  ) {
    blockchainId
    blockchainState
    id
    metadata
    modelId
    saleState
    serialNumber
  }
}
    `;
function useCompleteCheckoutWithDapperWalletMutation() {
    return Urql.useMutation(exports.CompleteCheckoutWithDapperWalletDocument);
}
exports.useCompleteCheckoutWithDapperWalletMutation = useCompleteCheckoutWithDapperWalletMutation;
;
exports.CompleteMarketplaceCancelDocument = (0, graphql_tag_1.default) `
    mutation CompleteMarketplaceCancel($id: ID!, $transactionId: String!) {
  completeMarketplaceCancel(id: $id, transactionId: $transactionId) {
    appId
    blockchainId
    id
    pricing {
      currency
      price
    }
    state
    transactionIds
  }
}
    `;
function useCompleteMarketplaceCancelMutation() {
    return Urql.useMutation(exports.CompleteMarketplaceCancelDocument);
}
exports.useCompleteMarketplaceCancelMutation = useCompleteMarketplaceCancelMutation;
;
exports.CompleteMarketplaceListDocument = (0, graphql_tag_1.default) `
    mutation CompleteMarketplaceList($nftId: ID!, $transactionId: String!) {
  completeMarketplaceList(nftId: $nftId, transactionId: $transactionId) {
    appId
    blockchainId
    id
    pricing {
      currency
      price
    }
    state
    transactionIds
  }
}
    `;
function useCompleteMarketplaceListMutation() {
    return Urql.useMutation(exports.CompleteMarketplaceListDocument);
}
exports.useCompleteMarketplaceListMutation = useCompleteMarketplaceListMutation;
;
exports.CompleteMarketplacePurchaseDocument = (0, graphql_tag_1.default) `
    mutation CompleteMarketplacePurchase($id: ID!, $transactionId: String!) {
  completeMarketplacePurchase(id: $id, transactionId: $transactionId) {
    appId
    blockchainId
    id
    pricing {
      currency
      price
    }
    state
    transactionIds
  }
}
    `;
function useCompleteMarketplacePurchaseMutation() {
    return Urql.useMutation(exports.CompleteMarketplacePurchaseDocument);
}
exports.useCompleteMarketplacePurchaseMutation = useCompleteMarketplacePurchaseMutation;
;
exports.CreateAdminUserDocument = (0, graphql_tag_1.default) `
    mutation CreateAdminUser($data: AdminUserCreateInput!) {
  createAdminUser(data: $data) {
    id
    name
  }
}
    `;
function useCreateAdminUserMutation() {
    return Urql.useMutation(exports.CreateAdminUserDocument);
}
exports.useCreateAdminUserMutation = useCreateAdminUserMutation;
;
exports.CreateAppDocument = (0, graphql_tag_1.default) `
    mutation CreateApp($data: AppCreateInput!) {
  createApp(data: $data) {
    id
    name
  }
}
    `;
function useCreateAppMutation() {
    return Urql.useMutation(exports.CreateAppDocument);
}
exports.useCreateAppMutation = useCreateAppMutation;
;
exports.CreateCustomTransactionDocument = (0, graphql_tag_1.default) `
    mutation CreateCustomTransaction($data: CustomTransactionCreateInput!, $appId: ID) {
  createCustomTransaction(data: $data, appId: $appId) {
    appId
    approvalState
    code
    hash
    id
    metadataScript
    name
  }
}
    `;
function useCreateCustomTransactionMutation() {
    return Urql.useMutation(exports.CreateCustomTransactionDocument);
}
exports.useCreateCustomTransactionMutation = useCreateCustomTransactionMutation;
;
exports.CreateFileUploadUrlDocument = (0, graphql_tag_1.default) `
    mutation CreateFileUploadUrl($appId: ID, $description: String, $name: String!, $options: CreateFileOptionsInput) {
  createFileUploadUrl(
    appId: $appId
    description: $description
    name: $name
    options: $options
  ) {
    id
    url
  }
}
    `;
function useCreateFileUploadUrlMutation() {
    return Urql.useMutation(exports.CreateFileUploadUrlDocument);
}
exports.useCreateFileUploadUrlMutation = useCreateFileUploadUrlMutation;
;
exports.CreateNftListingDocument = (0, graphql_tag_1.default) `
    mutation CreateNFTListing($data: CreateNFTListingInput!) {
  createNFTListing(data: $data) {
    appId
    attributes
    createdAt
    description
    id
    pricing {
      currency
      price
    }
    state
    title
    updatedAt
  }
}
    `;
function useCreateNftListingMutation() {
    return Urql.useMutation(exports.CreateNftListingDocument);
}
exports.useCreateNftListingMutation = useCreateNftListingMutation;
;
exports.CreateNftModelDocument = (0, graphql_tag_1.default) `
    mutation CreateNFTModel($appId: ID, $data: NFTModelCreateInput!, $setId: ID!) {
  createNFTModel(appId: $appId, data: $data, setId: $setId) {
    id
    quantity
    quantityMinted
    title
    status
    attributes
    metadata
    description
    content {
      id
      files {
        id
        url
      }
      poster {
        url
        id
      }
    }
  }
}
    `;
function useCreateNftModelMutation() {
    return Urql.useMutation(exports.CreateNftModelDocument);
}
exports.useCreateNftModelMutation = useCreateNftModelMutation;
;
exports.CreateNftSetDocument = (0, graphql_tag_1.default) `
    mutation CreateNFTSet($appId: ID, $data: NFTSetCreateInput!) {
  createNFTSet(appId: $appId, data: $data) {
    app {
      id
      name
    }
    attributes
    createdAt
    id
    metadata
    state
    tags
    title
    updatedAt
  }
}
    `;
function useCreateNftSetMutation() {
    return Urql.useMutation(exports.CreateNftSetDocument);
}
exports.useCreateNftSetMutation = useCreateNftSetMutation;
;
exports.CreateNiftoryWalletDocument = (0, graphql_tag_1.default) `
    mutation CreateNiftoryWallet($appId: ID, $userId: ID) {
  createNiftoryWallet(appId: $appId, userId: $userId) {
    address
    id
    state
    walletType
  }
}
    `;
function useCreateNiftoryWalletMutation() {
    return Urql.useMutation(exports.CreateNiftoryWalletDocument);
}
exports.useCreateNiftoryWalletMutation = useCreateNiftoryWalletMutation;
;
exports.CreateOrganizationDocument = (0, graphql_tag_1.default) `
    mutation CreateOrganization($data: OrganizationCreateInput!) {
  createOrganization(data: $data) {
    id
    name
  }
}
    `;
function useCreateOrganizationMutation() {
    return Urql.useMutation(exports.CreateOrganizationDocument);
}
exports.useCreateOrganizationMutation = useCreateOrganizationMutation;
;
exports.DeleteCredentialDocument = (0, graphql_tag_1.default) `
    mutation deleteCredential($clientId: ID!) {
  deleteCredential(clientId: $clientId) {
    apiKey
    clientId
    clientSecret
    redirectUris
    type
  }
}
    `;
function useDeleteCredentialMutation() {
    return Urql.useMutation(exports.DeleteCredentialDocument);
}
exports.useDeleteCredentialMutation = useDeleteCredentialMutation;
;
exports.DeleteCustomTransactionDocument = (0, graphql_tag_1.default) `
    mutation DeleteCustomTransaction($deleteCustomTransactionId: ID) {
  deleteCustomTransaction(id: $deleteCustomTransactionId) {
    appId
    approvalState
    code
    hash
    id
    metadataScript
    name
  }
}
    `;
function useDeleteCustomTransactionMutation() {
    return Urql.useMutation(exports.DeleteCustomTransactionDocument);
}
exports.useDeleteCustomTransactionMutation = useDeleteCustomTransactionMutation;
;
exports.DeleteNftListingDocument = (0, graphql_tag_1.default) `
    mutation DeleteNFTListing($deleteNftListingId: ID!) {
  deleteNFTListing(id: $deleteNftListingId) {
    appId
    attributes
    createdAt
    description
    id
    nftModel {
      id
      attributes
      status
      blockchainId
      metadata
      title
      description
      rarity
      quantity
      createdAt
      content {
        id
        poster {
          url
          state
          contentType
          id
        }
        files {
          url
          id
          state
          contentType
        }
      }
    }
    pricing {
      currency
      price
    }
    state
    title
    updatedAt
  }
}
    `;
function useDeleteNftListingMutation() {
    return Urql.useMutation(exports.DeleteNftListingDocument);
}
exports.useDeleteNftListingMutation = useDeleteNftListingMutation;
;
exports.DeleteNftModelDocument = (0, graphql_tag_1.default) `
    mutation DeleteNFTModel($id: ID!) {
  deleteNFTModel(id: $id) {
    attributes
    blockchainId
    createdAt
    description
    id
    metadata
    quantity
    quantityMinted
    rarity
    state
    status
    title
    updatedAt
  }
}
    `;
function useDeleteNftModelMutation() {
    return Urql.useMutation(exports.DeleteNftModelDocument);
}
exports.useDeleteNftModelMutation = useDeleteNftModelMutation;
;
exports.DeleteNftSetDocument = (0, graphql_tag_1.default) `
    mutation DeleteNFTSet($id: ID!) {
  deleteNFTSet(id: $id) {
    attributes
    blockchainId
    createdAt
    id
    image
    metadata
    state
    status
    tags
    title
    updatedAt
  }
}
    `;
function useDeleteNftSetMutation() {
    return Urql.useMutation(exports.DeleteNftSetDocument);
}
exports.useDeleteNftSetMutation = useDeleteNftSetMutation;
;
exports.DeleteOrganizationMemberDocument = (0, graphql_tag_1.default) `
    mutation deleteOrganizationMember($userId: ID!, $organizationId: ID!) {
  deleteOrganizationMember(userId: $userId, organizationId: $organizationId) {
    id
  }
}
    `;
function useDeleteOrganizationMemberMutation() {
    return Urql.useMutation(exports.DeleteOrganizationMemberDocument);
}
exports.useDeleteOrganizationMemberMutation = useDeleteOrganizationMemberMutation;
;
exports.DeployContractDocument = (0, graphql_tag_1.default) `
    mutation DeployContract($appId: String!, $blockchain: Blockchain!, $name: String!) {
  deployContract(appId: $appId, blockchain: $blockchain, name: $name) {
    address
    blockchain
    id
    name
    state
  }
}
    `;
function useDeployContractMutation() {
    return Urql.useMutation(exports.DeployContractDocument);
}
exports.useDeployContractMutation = useDeployContractMutation;
;
exports.ExecuteTransactionDocument = (0, graphql_tag_1.default) `
    mutation ExecuteTransaction($transaction: String!, $address: String, $userId: ID, $walletId: ID, $name: String, $args: JSONObject, $appId: ID, $transactionId: ID) {
  executeTransaction(
    transaction: $transaction
    address: $address
    userId: $userId
    walletId: $walletId
    name: $name
    args: $args
    appId: $appId
    transactionId: $transactionId
  ) {
    blockchain
    hash
    id
    name
    result
    state
  }
}
    `;
function useExecuteTransactionMutation() {
    return Urql.useMutation(exports.ExecuteTransactionDocument);
}
exports.useExecuteTransactionMutation = useExecuteTransactionMutation;
;
exports.MintNftModelDocument = (0, graphql_tag_1.default) `
    mutation MintNFTModel($appId: ID, $nftModelId: ID!, $quantity: PositiveInt) {
  mintNFTModel(appId: $appId, id: $nftModelId, quantity: $quantity) {
    attributes
    blockchainId
    content {
      id
      poster {
        contentType
        id
        url
      }
    }
    createdAt
    description
    id
    metadata
    quantity
    quantityMinted
    state
    status
    title
    updatedAt
  }
}
    `;
function useMintNftModelMutation() {
    return Urql.useMutation(exports.MintNftModelDocument);
}
exports.useMintNftModelMutation = useMintNftModelMutation;
;
exports.ReadyWalletDocument = (0, graphql_tag_1.default) `
    mutation readyWallet($address: String!) {
  readyWallet(address: $address) {
    id
    address
    state
  }
}
    `;
function useReadyWalletMutation() {
    return Urql.useMutation(exports.ReadyWalletDocument);
}
exports.useReadyWalletMutation = useReadyWalletMutation;
;
exports.RegisterWalletDocument = (0, graphql_tag_1.default) `
    mutation registerWallet($address: String!) {
  registerWallet(address: $address) {
    id
    address
    verificationCode
    state
  }
}
    `;
function useRegisterWalletMutation() {
    return Urql.useMutation(exports.RegisterWalletDocument);
}
exports.useRegisterWalletMutation = useRegisterWalletMutation;
;
exports.ReserveDocument = (0, graphql_tag_1.default) `
    mutation reserve($id: ID!) {
  reserve(listingId: $id) {
    createdAt
    id
    listingId
    state
    total
    updatedAt
    userId
  }
}
    `;
function useReserveMutation() {
    return Urql.useMutation(exports.ReserveDocument);
}
exports.useReserveMutation = useReserveMutation;
;
exports.SetPrimaryWalletDocument = (0, graphql_tag_1.default) `
    mutation SetPrimaryWallet($address: String, $walletId: String) {
  setPrimaryWallet(address: $address, walletId: $walletId) {
    address
    attributes
    createdAt
    id
    state
    updatedAt
    verificationCode
    walletType
  }
}
    `;
function useSetPrimaryWalletMutation() {
    return Urql.useMutation(exports.SetPrimaryWalletDocument);
}
exports.useSetPrimaryWalletMutation = useSetPrimaryWalletMutation;
;
exports.SignTransactionForDapperWalletDocument = (0, graphql_tag_1.default) `
    mutation SignTransactionForDapperWallet($transaction: String) {
  signTransactionForDapperWallet(transaction: $transaction)
}
    `;
function useSignTransactionForDapperWalletMutation() {
    return Urql.useMutation(exports.SignTransactionForDapperWalletDocument);
}
exports.useSignTransactionForDapperWalletMutation = useSignTransactionForDapperWalletMutation;
;
exports.SignTransactionDocument = (0, graphql_tag_1.default) `
    mutation SignTransaction($transaction: String!, $address: String, $appId: ID, $userId: ID, $walletId: ID) {
  signTransaction(
    transaction: $transaction
    address: $address
    appId: $appId
    userId: $userId
    walletId: $walletId
  )
}
    `;
function useSignTransactionMutation() {
    return Urql.useMutation(exports.SignTransactionDocument);
}
exports.useSignTransactionMutation = useSignTransactionMutation;
;
exports.TransferDocument = (0, graphql_tag_1.default) `
    mutation Transfer($address: String, $appId: ID, $force: Boolean, $nftId: ID, $nftModelId: ID, $userId: ID, $walletId: ID) {
  transfer(
    address: $address
    appId: $appId
    force: $force
    id: $nftId
    nftModelId: $nftModelId
    userId: $userId
    walletId: $walletId
  ) {
    blockchainId
    blockchainState
    id
    metadata
    model {
      blockchainId
      id
      title
    }
    serialNumber
    transactions {
      blockchain
      hash
      name
    }
    wallet {
      address
      id
    }
  }
}
    `;
function useTransferMutation() {
    return Urql.useMutation(exports.TransferDocument);
}
exports.useTransferMutation = useTransferMutation;
;
exports.UpdateAdminUserDocument = (0, graphql_tag_1.default) `
    mutation UpdateAdminUser($data: AdminUserUpdateInput!, $id: ID!) {
  updateAdminUser(data: $data, id: $id) {
    id
    name
    email
  }
}
    `;
function useUpdateAdminUserMutation() {
    return Urql.useMutation(exports.UpdateAdminUserDocument);
}
exports.useUpdateAdminUserMutation = useUpdateAdminUserMutation;
;
exports.UpdateAppDocument = (0, graphql_tag_1.default) `
    mutation UpdateApp($data: AppUpdateInput!, $appId: ID!) {
  updateApp(data: $data, appId: $appId) {
    id
  }
}
    `;
function useUpdateAppMutation() {
    return Urql.useMutation(exports.UpdateAppDocument);
}
exports.useUpdateAppMutation = useUpdateAppMutation;
;
exports.UpdateContractDocument = (0, graphql_tag_1.default) `
    mutation UpdateContract($data: ContractUpdateInput, $appId: ID!) {
  updateContract(data: $data, appId: $appId) {
    id
    version
  }
}
    `;
function useUpdateContractMutation() {
    return Urql.useMutation(exports.UpdateContractDocument);
}
exports.useUpdateContractMutation = useUpdateContractMutation;
;
exports.UpdateCredentialDocument = (0, graphql_tag_1.default) `
    mutation updateCredential($clientId: ID!, $data: CredentialUpdateInput!) {
  updateCredential(clientId: $clientId, data: $data) {
    apiKey
    clientId
    clientSecret
    redirectUris
    type
  }
}
    `;
function useUpdateCredentialMutation() {
    return Urql.useMutation(exports.UpdateCredentialDocument);
}
exports.useUpdateCredentialMutation = useUpdateCredentialMutation;
;
exports.UpdateNftListingDocument = (0, graphql_tag_1.default) `
    mutation UpdateNFTListing($data: UpdateNFTListingInput!, $id: ID!) {
  updateNFTListing(data: $data, id: $id) {
    appId
    attributes
    createdAt
    description
    id
    pricing {
      currency
      price
    }
    state
    title
    updatedAt
  }
}
    `;
function useUpdateNftListingMutation() {
    return Urql.useMutation(exports.UpdateNftListingDocument);
}
exports.useUpdateNftListingMutation = useUpdateNftListingMutation;
;
exports.UpdateNftModelDocument = (0, graphql_tag_1.default) `
    mutation UpdateNFTModel($data: NFTModelUpdateInput!, $id: ID!) {
  updateNFTModel(data: $data, id: $id) {
    attributes
    blockchainId
    createdAt
    description
    id
    metadata
    quantity
    quantityMinted
    rarity
    state
    status
    title
    updatedAt
  }
}
    `;
function useUpdateNftModelMutation() {
    return Urql.useMutation(exports.UpdateNftModelDocument);
}
exports.useUpdateNftModelMutation = useUpdateNftModelMutation;
;
exports.UpdateNftSetDocument = (0, graphql_tag_1.default) `
    mutation UpdateNFTSet($data: NFTSetUpdateInput!, $id: ID!, $appId: ID) {
  updateNFTSet(data: $data, id: $id, appId: $appId) {
    attributes
    blockchainId
    createdAt
    id
    image
    metadata
    state
    status
    tags
    tags
    title
    updatedAt
  }
}
    `;
function useUpdateNftSetMutation() {
    return Urql.useMutation(exports.UpdateNftSetDocument);
}
exports.useUpdateNftSetMutation = useUpdateNftSetMutation;
;
exports.UpdateOrganizationMemberDocument = (0, graphql_tag_1.default) `
    mutation UpdateOrganizationMember($data: OrganizationMemberUpdateInput!) {
  updateOrganizationMember(data: $data) {
    id
    name
  }
}
    `;
function useUpdateOrganizationMemberMutation() {
    return Urql.useMutation(exports.UpdateOrganizationMemberDocument);
}
exports.useUpdateOrganizationMemberMutation = useUpdateOrganizationMemberMutation;
;
exports.UpdateOrganizationDocument = (0, graphql_tag_1.default) `
    mutation UpdateOrganization($id: ID!, $data: OrganizationUpdateInput!) {
  updateOrganization(id: $id, data: $data) {
    id
    name
  }
}
    `;
function useUpdateOrganizationMutation() {
    return Urql.useMutation(exports.UpdateOrganizationDocument);
}
exports.useUpdateOrganizationMutation = useUpdateOrganizationMutation;
;
exports.UploadNftContentDocument = (0, graphql_tag_1.default) `
    mutation UploadNFTContent($contentType: String, $description: String, $name: String, $posterContentType: String) {
  uploadNFTContent(
    contentType: $contentType
    description: $description
    name: $name
    posterContentType: $posterContentType
  ) {
    files {
      contentType
      id
      md5
      name
      state
      url
    }
    id
    poster {
      contentType
      id
      md5
      name
      state
      url
    }
  }
}
    `;
function useUploadNftContentMutation() {
    return Urql.useMutation(exports.UploadNftContentDocument);
}
exports.useUploadNftContentMutation = useUploadNftContentMutation;
;
exports.VerifyWalletDocument = (0, graphql_tag_1.default) `
    mutation verifyWallet($address: String!, $signedVerificationCode: JSON!) {
  verifyWallet(address: $address, signedVerificationCode: $signedVerificationCode) {
    id
    address
    state
  }
}
    `;
function useVerifyWalletMutation() {
    return Urql.useMutation(exports.VerifyWalletDocument);
}
exports.useVerifyWalletMutation = useVerifyWalletMutation;
;
exports.WithdrawDocument = (0, graphql_tag_1.default) `
    mutation Withdraw($appId: ID, $id: ID!, $niftoryWalletAddress: String, $receiverAddress: String!) {
  withdraw(
    appId: $appId
    id: $id
    niftoryWalletAddress: $niftoryWalletAddress
    receiverAddress: $receiverAddress
  ) {
    blockchainId
    blockchainState
    id
    metadata
    model {
      blockchainId
      id
      title
    }
    modelId
    serialNumber
    wallet {
      address
      id
    }
  }
}
    `;
function useWithdrawMutation() {
    return Urql.useMutation(exports.WithdrawDocument);
}
exports.useWithdrawMutation = useWithdrawMutation;
;
exports.AdminUserByIdDocument = (0, graphql_tag_1.default) `
    query AdminUserById($id: ID!, $appId: ID) {
  adminUserById(id: $id, appId: $appId) {
    apps {
      contract {
        address
        id
      }
      id
      name
    }
    id
    organizations {
      id
      name
    }
    id
    email
    name
    role
  }
}
    `;
function useAdminUserByIdQuery(options) {
    return Urql.useQuery({ query: exports.AdminUserByIdDocument, ...options });
}
exports.useAdminUserByIdQuery = useAdminUserByIdQuery;
;
exports.AdminUserDocument = (0, graphql_tag_1.default) `
    query AdminUser {
  adminUser {
    apps {
      contract {
        address
        blockchain
        id
        name
        state
        metadata
      }
      organization {
        id
        name
        members {
          id
          organizationRole
        }
      }
      name
      id
      storageAddress
      blockchain
    }
    organizations {
      id
      name
      members {
        id
        organizationRole
      }
    }
    id
    email
    name
    role
    tosAcceptanceDateTime
  }
}
    `;
function useAdminUserQuery(options) {
    return Urql.useQuery({ query: exports.AdminUserDocument, ...options });
}
exports.useAdminUserQuery = useAdminUserQuery;
;
exports.AdminUsersDocument = (0, graphql_tag_1.default) `
    query AdminUsers($maxResults: PositiveInt, $cursor: String, $filter: AdminUsersFilterInput) {
  adminUsers(maxResults: $maxResults, cursor: $cursor, filter: $filter) {
    items {
      apps {
        organization {
          id
          name
        }
        name
        id
        storageAddress
        blockchain
      }
      id
      email
      name
      role
    }
    cursor
  }
}
    `;
function useAdminUsersQuery(options) {
    return Urql.useQuery({ query: exports.AdminUsersDocument, ...options });
}
exports.useAdminUsersQuery = useAdminUsersQuery;
;
exports.AppByIdDocument = (0, graphql_tag_1.default) `
    query AppById($id: ID!) {
  appById(id: $id) {
    contract {
      id
      name
      blockchain
      address
      state
      metadata
      version
    }
    storageAddress
    dapperMerchantAccountAddress
    id
    credentials {
      apiKey
      clientId
      clientSecret
      redirectUris
      type
    }
    name
    concurrency
    keyPoolSize
  }
}
    `;
function useAppByIdQuery(options) {
    return Urql.useQuery({ query: exports.AppByIdDocument, ...options });
}
exports.useAppByIdQuery = useAppByIdQuery;
;
exports.AppUserByIdDocument = (0, graphql_tag_1.default) `
    query AppUserById($id: ID!, $appId: ID) {
  appUserById(id: $id, appId: $appId) {
    createdAt
    email
    id
    image
    name
    updatedAt
    app {
      id
      name
    }
    wallets {
      id
      address
      state
      verificationCode
      walletType
    }
    primaryWallet {
      id
      address
      state
      walletType
    }
  }
}
    `;
function useAppUserByIdQuery(options) {
    return Urql.useQuery({ query: exports.AppUserByIdDocument, ...options });
}
exports.useAppUserByIdQuery = useAppUserByIdQuery;
;
exports.AppUserDocument = (0, graphql_tag_1.default) `
    query AppUser {
  appUser {
    createdAt
    email
    id
    image
    name
    updatedAt
    app {
      id
      name
    }
    wallets {
      id
      address
      state
      verificationCode
      walletType
    }
    primaryWallet {
      id
      address
      state
      walletType
    }
  }
}
    `;
function useAppUserQuery(options) {
    return Urql.useQuery({ query: exports.AppUserDocument, ...options });
}
exports.useAppUserQuery = useAppUserQuery;
;
exports.AppUsersDocument = (0, graphql_tag_1.default) `
    query AppUsers($cursor: String, $maxResults: PositiveInt, $appId: ID, $filter: AppUsersFilterInput) {
  appUsers(
    cursor: $cursor
    maxResults: $maxResults
    appId: $appId
    filter: $filter
  ) {
    cursor
    items {
      app {
        id
        name
      }
      createdAt
      email
      id
      image
      name
      updatedAt
      primaryWallet {
        id
        address
        state
        walletType
      }
    }
  }
}
    `;
function useAppUsersQuery(options) {
    return Urql.useQuery({ query: exports.AppUsersDocument, ...options });
}
exports.useAppUsersQuery = useAppUsersQuery;
;
exports.AppDocument = (0, graphql_tag_1.default) `
    query App {
  app {
    contract {
      id
      name
      blockchain
      address
      state
      metadata
      version
    }
    storageAddress
    dapperMerchantAccountAddress
    id
    credentials {
      apiKey
      clientId
      clientSecret
      redirectUris
      type
    }
    name
  }
}
    `;
function useAppQuery(options) {
    return Urql.useQuery({ query: exports.AppDocument, ...options });
}
exports.useAppQuery = useAppQuery;
;
exports.AppsDocument = (0, graphql_tag_1.default) `
    query Apps($cursor: String, $filter: AppsFilterInput, $maxResults: PositiveInt) {
  apps(cursor: $cursor, filter: $filter, maxResults: $maxResults) {
    cursor
    items {
      contract {
        id
        name
        blockchain
        address
        state
        metadata
        version
      }
      storageAddress
      id
      name
    }
  }
}
    `;
function useAppsQuery(options) {
    return Urql.useQuery({ query: exports.AppsDocument, ...options });
}
exports.useAppsQuery = useAppsQuery;
;
exports.BlockchainTransactionDocument = (0, graphql_tag_1.default) `
    query BlockchainTransaction($hash: String, $id: ID) {
  blockchainTransaction(hash: $hash, id: $id) {
    blockchain
    hash
    id
    name
    result
    state
  }
}
    `;
function useBlockchainTransactionQuery(options) {
    return Urql.useQuery({ query: exports.BlockchainTransactionDocument, ...options });
}
exports.useBlockchainTransactionQuery = useBlockchainTransactionQuery;
;
exports.StatsDocument = (0, graphql_tag_1.default) `
    query Stats($appId: ID) {
  userStats(appId: $appId) {
    totalUsers
  }
  walletStats(appId: $appId) {
    totalWallets
  }
  saleStats(appId: $appId) {
    listingsSold
    totalSales
    uniqueBuyers
    uniqueListingsSold
  }
}
    `;
function useStatsQuery(options) {
    return Urql.useQuery({ query: exports.StatsDocument, ...options });
}
exports.useStatsQuery = useStatsQuery;
;
exports.ContractDocument = (0, graphql_tag_1.default) `
    query Contract($appId: ID) {
  contract(appId: $appId) {
    address
    blockchain
    id
    name
    state
    ... on FlowContract {
      transactions {
        createMarketplaceListing {
          usd
          flow
        }
        purchaseMarketplaceListing {
          flow {
            transaction
            metadataScript
          }
          usd {
            transaction
            metadataScript
          }
        }
        cancelMarketplaceListing
      }
    }
  }
}
    `;
function useContractQuery(options) {
    return Urql.useQuery({ query: exports.ContractDocument, ...options });
}
exports.useContractQuery = useContractQuery;
;
exports.CustomTransactionDocument = (0, graphql_tag_1.default) `
    query CustomTransaction($customTransactionId: ID) {
  customTransaction(id: $customTransactionId) {
    appId
    approvalState
    code
    hash
    id
    metadataScript
    name
  }
}
    `;
function useCustomTransactionQuery(options) {
    return Urql.useQuery({ query: exports.CustomTransactionDocument, ...options });
}
exports.useCustomTransactionQuery = useCustomTransactionQuery;
;
exports.CustomTransactionsDocument = (0, graphql_tag_1.default) `
    query CustomTransactions($appId: ID, $cursor: String, $maxResults: PositiveInt, $search: String) {
  customTransactions(
    appId: $appId
    cursor: $cursor
    maxResults: $maxResults
    search: $search
  ) {
    cursor
    items {
      appId
      approvalState
      code
      hash
      id
      metadataScript
      name
    }
  }
}
    `;
function useCustomTransactionsQuery(options) {
    return Urql.useQuery({ query: exports.CustomTransactionsDocument, ...options });
}
exports.useCustomTransactionsQuery = useCustomTransactionsQuery;
;
exports.FileDocument = (0, graphql_tag_1.default) `
    query File($id: ID!) {
  file(id: $id) {
    contentType
    id
    md5
    name
    state
    url
  }
}
    `;
function useFileQuery(options) {
    return Urql.useQuery({ query: exports.FileDocument, ...options });
}
exports.useFileQuery = useFileQuery;
;
exports.InvoicesDocument = (0, graphql_tag_1.default) `
    query Invoices($appId: ID, $cursor: String, $maxResults: PositiveInt, $filter: InvoicesFilterInput) {
  invoices(
    appId: $appId
    cursor: $cursor
    maxResults: $maxResults
    filter: $filter
  ) {
    cursor
    items {
      createdAt
      id
      listingId
      state
      total
      updatedAt
      userId
    }
  }
}
    `;
function useInvoicesQuery(options) {
    return Urql.useQuery({ query: exports.InvoicesDocument, ...options });
}
exports.useInvoicesQuery = useInvoicesQuery;
;
exports.MarketplaceListingDocument = (0, graphql_tag_1.default) `
    query MarketplaceListing($id: ID, $nftId: ID) {
  marketplaceListing(id: $id, nftId: $nftId) {
    appId
    id
    nft {
      blockchainId
      blockchainState
      id
      metadata
      model {
        id
        attributes
        status
        blockchainId
        metadata
        title
        description
        rarity
        quantity
        createdAt
        content {
          id
          poster {
            url
            state
            contentType
            id
          }
          files {
            url
            id
            state
            contentType
          }
        }
      }
      modelId
      saleState
      serialNumber
      status
      wallet {
        id
        address
        state
      }
    }
    pricing {
      currency
      price
    }
    wallet {
      id
      address
      state
    }
    blockchainId
    state
    transactionIds
  }
}
    `;
function useMarketplaceListingQuery(options) {
    return Urql.useQuery({ query: exports.MarketplaceListingDocument, ...options });
}
exports.useMarketplaceListingQuery = useMarketplaceListingQuery;
;
exports.MarketplaceListingsDocument = (0, graphql_tag_1.default) `
    query MarketplaceListings($appId: ID, $cursor: String, $filter: MarketplaceListingFilterInput, $maxResults: PositiveInt) {
  marketplaceListings(
    appId: $appId
    cursor: $cursor
    filter: $filter
    maxResults: $maxResults
  ) {
    cursor
    items {
      appId
      id
      nft {
        blockchainId
        blockchainState
        id
        metadata
        model {
          id
          attributes
          status
          blockchainId
          metadata
          title
          description
          rarity
          quantity
          createdAt
          content {
            id
            poster {
              url
              state
              contentType
              id
            }
            files {
              url
              id
              state
              contentType
            }
          }
        }
        modelId
        saleState
        serialNumber
        status
        wallet {
          id
          address
          state
        }
      }
      pricing {
        currency
        price
      }
      wallet {
        id
        address
        state
      }
      blockchainId
      state
      transactionIds
    }
  }
}
    `;
function useMarketplaceListingsQuery(options) {
    return Urql.useQuery({ query: exports.MarketplaceListingsDocument, ...options });
}
exports.useMarketplaceListingsQuery = useMarketplaceListingsQuery;
;
exports.NftListingDocument = (0, graphql_tag_1.default) `
    query NftListing($id: ID!) {
  nftListing(id: $id) {
    appId
    attributes
    createdAt
    description
    id
    nftModel {
      id
      attributes
      status
      blockchainId
      metadata
      title
      description
      rarity
      quantity
      createdAt
      content {
        id
        poster {
          url
          state
          contentType
          id
        }
        files {
          url
          id
          state
          contentType
        }
      }
    }
    pricing {
      currency
      price
    }
    state
    title
    updatedAt
  }
}
    `;
function useNftListingQuery(options) {
    return Urql.useQuery({ query: exports.NftListingDocument, ...options });
}
exports.useNftListingQuery = useNftListingQuery;
;
exports.NftListingsDocument = (0, graphql_tag_1.default) `
    query NftListings($appId: ID, $cursor: String, $filter: NFTListingFilterInput, $maxResults: PositiveInt) {
  nftListings(
    appId: $appId
    cursor: $cursor
    filter: $filter
    maxResults: $maxResults
  ) {
    cursor
    items {
      appId
      attributes
      createdAt
      description
      id
      nftModel {
        id
        attributes
        status
        blockchainId
        metadata
        title
        description
        rarity
        quantity
        createdAt
        content {
          id
          poster {
            url
            state
            contentType
            id
          }
          files {
            url
            id
            state
            contentType
          }
        }
      }
      pricing {
        currency
        price
      }
      state
      title
      updatedAt
    }
  }
}
    `;
function useNftListingsQuery(options) {
    return Urql.useQuery({ query: exports.NftListingsDocument, ...options });
}
exports.useNftListingsQuery = useNftListingsQuery;
;
exports.NftModelDocument = (0, graphql_tag_1.default) `
    query NFTModel($id: ID!) {
  nftModel(id: $id) {
    attributes
    blockchainId
    content {
      files {
        contentType
        id
        ipfsContentAddress
        url
      }
      id
      poster {
        contentType
        id
        url
      }
    }
    createdAt
    description
    id
    metadata
    quantity
    quantityMinted
    set {
      id
      title
    }
    nftListings {
      id
      description
      createdAt
      attributes
      pricing {
        price
      }
      state
      title
      updatedAt
    }
    state
    status
    title
    updatedAt
  }
}
    `;
function useNftModelQuery(options) {
    return Urql.useQuery({ query: exports.NftModelDocument, ...options });
}
exports.useNftModelQuery = useNftModelQuery;
;
exports.NftModelsDocument = (0, graphql_tag_1.default) `
    query NftModels($appId: ID, $cursor: String, $filter: NFTModelFilterInput, $maxResults: PositiveInt) {
  nftModels(
    appId: $appId
    cursor: $cursor
    filter: $filter
    maxResults: $maxResults
  ) {
    cursor
    items {
      attributes
      blockchainId
      content {
        files {
          contentType
          id
          ipfsContentAddress
          url
        }
        id
        poster {
          contentType
          id
          url
        }
      }
      createdAt
      description
      id
      metadata
      quantity
      quantityMinted
      set {
        id
        title
      }
      state
      status
      title
      updatedAt
    }
  }
}
    `;
function useNftModelsQuery(options) {
    return Urql.useQuery({ query: exports.NftModelsDocument, ...options });
}
exports.useNftModelsQuery = useNftModelsQuery;
;
exports.NftSetsDocument = (0, graphql_tag_1.default) `
    query NftSets($appId: ID, $cursor: String, $filter: NFTSetFilterInput, $maxResults: PositiveInt) {
  nftSets(
    appId: $appId
    cursor: $cursor
    filter: $filter
    maxResults: $maxResults
  ) {
    cursor
    items {
      app {
        id
        name
      }
      id
      state
      tags
      title
      models {
        id
      }
      blockchainId
      updatedAt
    }
  }
}
    `;
function useNftSetsQuery(options) {
    return Urql.useQuery({ query: exports.NftSetsDocument, ...options });
}
exports.useNftSetsQuery = useNftSetsQuery;
;
exports.NftDocument = (0, graphql_tag_1.default) `
    query Nft($id: ID!) {
  nft(id: $id) {
    blockchainId
    blockchainState
    id
    metadata
    model {
      id
      attributes
      status
      blockchainId
      metadata
      title
      description
      rarity
      quantity
      content {
        id
        poster {
          url
          state
          contentType
          id
        }
        files {
          url
          id
          state
          contentType
        }
      }
    }
    serialNumber
    transactions {
      blockchain
      hash
      name
    }
    wallet {
      address
      id
    }
    marketplaceListings {
      id
      blockchainId
      state
    }
  }
}
    `;
function useNftQuery(options) {
    return Urql.useQuery({ query: exports.NftDocument, ...options });
}
exports.useNftQuery = useNftQuery;
;
exports.NftsByWalletDocument = (0, graphql_tag_1.default) `
    query NftsByWallet($address: String, $cursor: String, $filter: NFTFilterInput, $maxResults: PositiveInt, $walletId: ID) {
  nftsByWallet(
    address: $address
    cursor: $cursor
    filter: $filter
    maxResults: $maxResults
    walletId: $walletId
  ) {
    cursor
    items {
      blockchainId
      blockchainState
      id
      metadata
      model {
        attributes
        blockchainId
        createdAt
        description
        id
        metadata
        quantity
        quantityMinted
        rarity
        state
        status
        title
        updatedAt
        content {
          id
          poster {
            url
            state
            contentType
            id
          }
        }
      }
      modelId
      saleState
      serialNumber
    }
  }
}
    `;
function useNftsByWalletQuery(options) {
    return Urql.useQuery({ query: exports.NftsByWalletDocument, ...options });
}
exports.useNftsByWalletQuery = useNftsByWalletQuery;
;
exports.NftsDocument = (0, graphql_tag_1.default) `
    query Nfts($appId: ID, $cursor: String, $filter: NFTFilterInput, $maxResults: PositiveInt, $userId: ID) {
  nfts(
    appId: $appId
    cursor: $cursor
    filter: $filter
    maxResults: $maxResults
    userId: $userId
  ) {
    cursor
    items {
      updatedAt
      blockchainId
      blockchainState
      id
      metadata
      model {
        attributes
        blockchainId
        createdAt
        description
        id
        metadata
        quantity
        quantityMinted
        rarity
        state
        status
        title
        updatedAt
        content {
          id
          poster {
            url
            state
            contentType
            id
          }
          files {
            url
            state
            contentType
            id
          }
        }
      }
      modelId
      saleState
      serialNumber
      wallet {
        walletType
        address
        id
      }
    }
  }
}
    `;
function useNftsQuery(options) {
    return Urql.useQuery({ query: exports.NftsDocument, ...options });
}
exports.useNftsQuery = useNftsQuery;
;
exports.OrganizationByIdDocument = (0, graphql_tag_1.default) `
    query OrganizationById($id: ID!) {
  organizationById(id: $id) {
    id
    name
    apps {
      id
      name
    }
    members {
      id
      image
      name
      email
      organizationRole
      apps {
        id
        name
      }
    }
  }
}
    `;
function useOrganizationByIdQuery(options) {
    return Urql.useQuery({ query: exports.OrganizationByIdDocument, ...options });
}
exports.useOrganizationByIdQuery = useOrganizationByIdQuery;
;
exports.SaleStatsDocument = (0, graphql_tag_1.default) `
    query SaleStats($appId: ID, $filter: SalesStatFilterInput) {
  saleStats(appId: $appId, filter: $filter) {
    totalSales
    listingsSold
    uniqueListingsSold
    uniqueBuyers
  }
}
    `;
function useSaleStatsQuery(options) {
    return Urql.useQuery({ query: exports.SaleStatsDocument, ...options });
}
exports.useSaleStatsQuery = useSaleStatsQuery;
;
exports.SetDocument = (0, graphql_tag_1.default) `
    query Set($id: ID!) {
  set(id: $id) {
    blockchainId
    id
    state
    title
    image
    metadata
  }
}
    `;
function useSetQuery(options) {
    return Urql.useQuery({ query: exports.SetDocument, ...options });
}
exports.useSetQuery = useSetQuery;
;
exports.SetsDocument = (0, graphql_tag_1.default) `
    query Sets($appId: ID, $filter: NFTSetFilterInput) {
  sets(appId: $appId, filter: $filter) {
    app {
      id
      name
    }
    id
    state
    tags
    title
    models {
      id
    }
    blockchainId
  }
}
    `;
function useSetsQuery(options) {
    return Urql.useQuery({ query: exports.SetsDocument, ...options });
}
exports.useSetsQuery = useSetsQuery;
;
exports.UserStatsDocument = (0, graphql_tag_1.default) `
    query UserStats($appId: ID) {
  userStats(appId: $appId) {
    totalUsers
  }
}
    `;
function useUserStatsQuery(options) {
    return Urql.useQuery({ query: exports.UserStatsDocument, ...options });
}
exports.useUserStatsQuery = useUserStatsQuery;
;
exports.WalletByAddressDocument = (0, graphql_tag_1.default) `
    query WalletByAddress($address: String!, $appId: ID) {
  walletByAddress(address: $address, appId: $appId) {
    address
    attributes
    createdAt
    id
    appUser {
      email
      id
      name
    }
    state
    updatedAt
    verificationCode
    walletType
  }
}
    `;
function useWalletByAddressQuery(options) {
    return Urql.useQuery({ query: exports.WalletByAddressDocument, ...options });
}
exports.useWalletByAddressQuery = useWalletByAddressQuery;
;
exports.WalletByIdDocument = (0, graphql_tag_1.default) `
    query WalletById($walletById: ID!) {
  walletById(id: $walletById) {
    address
    attributes
    createdAt
    id
    nfts {
      id
      modelId
      serialNumber
    }
    state
    updatedAt
    verificationCode
    walletType
  }
}
    `;
function useWalletByIdQuery(options) {
    return Urql.useQuery({ query: exports.WalletByIdDocument, ...options });
}
exports.useWalletByIdQuery = useWalletByIdQuery;
;
exports.WalletsDocument = (0, graphql_tag_1.default) `
    query Wallets($appId: ID!, $cursor: String, $maxResults: PositiveInt, $filter: WalletsFilterInput) {
  wallets(
    appId: $appId
    cursor: $cursor
    maxResults: $maxResults
    filter: $filter
  ) {
    cursor
    items {
      address
      appUser {
        email
        id
        name
        updatedAt
      }
      attributes
      id
      state
      updatedAt
      walletType
      nftCount
    }
  }
}
    `;
function useWalletsQuery(options) {
    return Urql.useQuery({ query: exports.WalletsDocument, ...options });
}
exports.useWalletsQuery = useWalletsQuery;
;
exports.WalletStatsDocument = (0, graphql_tag_1.default) `
    query WalletStats($appId: ID) {
  walletStats(appId: $appId) {
    totalWallets
  }
}
    `;
function useWalletStatsQuery(options) {
    return Urql.useQuery({ query: exports.WalletStatsDocument, ...options });
}
exports.useWalletStatsQuery = useWalletStatsQuery;
;
exports.WalletDocument = (0, graphql_tag_1.default) `
    query Wallet {
  wallet {
    nfts {
      id
    }
    attributes
    id
    walletType
    address
    state
    verificationCode
    appUser {
      email
    }
  }
}
    `;
function useWalletQuery(options) {
    return Urql.useQuery({ query: exports.WalletDocument, ...options });
}
exports.useWalletQuery = useWalletQuery;
;
